/**
 * Created by jonathan.kernick on 06/09/2016.
 */
var Widgets = {
    setAssetParams: function (asset, json) {
        if (json.align) {
            json.padding = json.padding || {x: 0, y: 0};
            asset.alignX = json.align.indexOf("l") != -1 ? 1 : -1;
            asset.alignY = json.align.indexOf("t") != -1 ? 1 : -1;
            if (json.align == "tc" || json.align == "bc") asset.alignX = 0;
            if (json.align == "cl" || json.align == "cr") asset.alignY = 0;
            asset.resize = function (w, h) {
                if (asset.alignX !== 0)
                    this.x = this.alignX * (json.padding.x + (this.width - w) * 0.5);
                if (asset.alignY !== 0)
                    this.y = this.alignY * (json.padding.y + (this.height - h) * 0.5);
            };
            asset.resize(CC.WebApp.current.screenWidth, CC.WebApp.current.screenHeight);
        }
        if (json.position) {
            asset.x = json.position.x;
            asset.y = json.position.y;
        }
        if (json.anchor) {
            asset.anchor.x = json.anchor.x;
            asset.anchor.y = json.anchor.y;
        }
        if (json.animations) {
            for (var i = 0; i < json.animations.length; i++) {
                var anim = json.animations[i];
                if (anim.oscillate) {
                    var animItem = anim.oscillate;
                    var initialValue = 0;
                    if (json.position) {
                        if (json.position[animItem.param]) {
                            initialValue = json.position[animItem.param];
                        }
                    }
                    var animTimer = 0;
                    var math2PI = Math.PI * 2;
                    asset.update = function (delta) {
                        animTimer += delta;
                        this[animItem.param] = initialValue + Math.sin(animTimer * math2PI) * animItem.magnitude;
                    }
                }
            }
        }
        return asset;

    },
    createAsset: function (json) {
        var returnAsset;

        var singleTexturePath, multipleTexturePath;

        if (json.mobile_texture && CC.isMobile) {
            singleTexturePath = json.mobile_texture;
        }
        else if (json.desktop_texture && !CC.isMobile) {
            singleTexturePath = json.desktop_texture;
        }
        else if (json.texture) {
            singleTexturePath = json.texture;
        }

        if (singleTexturePath) {
            returnAsset = CC.Utility.pixiSprite(singleTexturePath);
            returnAsset.isAnimated = false;
        }
        else {
            if (json.mobile_textures && CC.isMobile) {
                multipleTexturePath = json.mobile_textures;
            }
            else if (json.desktop_textures && !CC.isMobile) {
                multipleTexturePath = json.desktop_textures;
            }
            else if (json.textures) {
                multipleTexturePath = json.textures;
            }

            if (multipleTexturePath) {
                returnAsset = CC.Utility.pixiMovieClip(multipleTexturePath);
                returnAsset.isAnimated = true;
                if (json.fps) {
                    returnAsset.animationSpeed = json.fps / 60;
                }
            }
        }
        return Widgets.setAssetParams(returnAsset, json);
    },
    createMovieClipAsset: function (json) {
        var returnAsset = CC.Utility.pixiMovieClip(json.textures);
        return Widgets.setAssetParams(returnAsset, json);
    }
    ,
    createButtonAsset: function (json, func, triggerFuncFirst, clickSound) {
        var triggerFunctionFirst = !!triggerFuncFirst;
        func = func || function () {
            };
        var button = Widgets.createAsset(json);
        var buttonFunction = function () {
            sound.play(Screens.json.audio.click);
            this.scale.set(0.8);
            if (triggerFunctionFirst) {
                func.call(this);
                TweenLite.to(this.scale, 0.5, {x: 1, y: 1});
            } else {
                TweenLite.to(this.scale, 0.5, {x: 1, y: 1, onComplete: func.bind(this)});
            }
        };
        CC.ScreensUtility.createButton(button, buttonFunction);
        return button;
    }
    ,
    createBackgroundAsset: function (json) {
        var background = new PIXI.Container();
        if (json.texture_a) {
            var top = new CC.Utility.pixiSprite(json.texture_a);
            top.anchor.y = 0;
            top.y = -1136 * .5;
            background.addChild(top);
        }
        if (json.texture_b) {
            var bottom = new CC.Utility.pixiSprite(json.texture_b);
            bottom.anchor.y = 1;
            bottom.y = 1136 * 0.5;
            background.addChild(bottom);
        }
        return background;
    }
    ,
    createSelectionCarousel: function (items, json, index) {
        var i, item;
        var container = new PIXI.Container();
        var swipeLayer = new PIXI.Container();

        swipeLayer.hitArea = new PIXI.Rectangle(-1000, -1000, 2000, 2000);
        swipeLayer.interactive = true;
        var startTouchX;
        swipeLayer.touchstart = function (event) {
            startTouchX = event.data.getLocalPosition(this).x;
        };
        swipeLayer.touchmove = function (event) {
            //  startTouchX = event.data.getLocalPosition(this).x;
        };
        swipeLayer.touchend = swipeLayer.touchendoutside = function (event) {
            var touchX = event.data.getLocalPosition(this).x;
            var diff = startTouchX - touchX;
            if (Math.abs(diff) > 10) {
                if (diff > 0) {
                    container.next();
                }
                else {
                    container.prev();
                }
            }
        };
        container.items = items;
        container.currentPos = index;
        container.next = function () {
            this.items[this.currentPos].x = 0;
            this.items[this.currentPos].hide();
            TweenLite.to(this.items[this.currentPos], 0.3, {x: -640});

            this.currentPos = Math.modo(this.currentPos + 1, this.items.length);
            this.items[this.currentPos].x = 640;
            TweenLite.to(this.items[this.currentPos], 0.3, {x: 0, onComplete: this.items[this.currentPos].show});
        };
        container.prev = function () {
            this.items[this.currentPos].x = 0;
            this.items[this.currentPos].hide();
            TweenLite.to(this.items[this.currentPos], 0.3, {x: 640});

            this.currentPos = Math.modo(this.currentPos - 1, this.items.length);
            this.items[this.currentPos].x = -640;
            TweenLite.to(this.items[this.currentPos], 0.3, {x: 0, onComplete: this.items[this.currentPos].show});
        };
        //tween the items on and then call a function at the end
        for (i = 0; i < items.length; ++i) {
            item = items[i];
            container.addChild(item);
            item.x = 640 * !!(i - container.currentPos);
            if (!item.show) {
                item.show = function () {
                };
            }
            if (!item.hide) {
                item.hide = function () {
                };
            }
            //item.visible = false;
        }
        container.buttonLeft = this.createButtonAsset(json.left_btn, container.prev.bind(container));
        container.buttonRight = this.createButtonAsset(json.right_btn, container.next.bind(container));
        container.addChild(swipeLayer);
        container.addChild(container.buttonRight);
        container.addChild(container.buttonLeft);
        return container;
    }
    ,
    createButtonQuick: function (imageUrl, func) {
        func = func || function () {
            };
        var button = CC.Utility.pixiSprite(imageUrl);
        var buttonFunction = function () {
            sound.play("pop");
            this.scale.set(0.8);
            func.call(this);
            TweenLite.to(this.scale, 0.5, {x: 1, y: 1});
        };
        CC.ScreensUtility.createButton(button, buttonFunction);
        return button;
    }
    ,
    createButtonAlt: function (imageUrls, func) {
        func = func || function () {
            };
        var button = CC.Utility.pixiAtlasMovieClip(imageUrls);
        var buttonFunction = function () {
            sound.play("pop");
            this.scale.set(0.8);
            func.call(this);
            TweenLite.to(this.scale, 0.5, {x: 1, y: 1});
        };
        CC.ScreensUtility.createButtonHighlight(button, buttonFunction);
        return button;
    }
    ,
    createFrameIndicator: function () {
        var container = new PIXI.Container();
        var numberContainer = new PIXI.Container();
        var numberSway = new PIXI.Container();
        var number = new PIXI.extras.BitmapText("1", {font: "40px VAGRounded", fill: 0xFFFFFF});
        numberContainer.scale.y = 0.9;
        number.anchor.x = 0;
        number.anchor.y = 0;
        numberContainer.rotation = Math.PI * 0.25;
        numberSway.rotation = Math.PI * -0.25;
        numberContainer.x = 136;
        numberContainer.y = -194;
        number.x = number.width * -0.5;
        var back = CC.Utility.pixiSprite("frame_indicator.png");
        container.addChild(back);
        container.addChild(numberContainer);
        numberSway.addChild(number);
        numberContainer.addChild(numberSway);
        container.setNumber = function (num) {
            number.text = num;
            number.x = number.width * -0.5;
        };
        return container;
    }
    ,
    createMuteButton: function (button_mute, button_unmute, replayMusic) {
        var container = new PIXI.Container();
        var muteToggle = function () {
            if (sound.muted) {
                sound.mute(false);
            } else {
                sound.mute(true);
            }
            button_mute.visible = sound.muted;
            button_unmute.visible = !sound.muted;
        };
        var button_mute = this.createButtonAsset(button_mute, muteToggle);
        var button_unmute = this.createButtonAsset(button_unmute, muteToggle);
        container.addChild(button_mute);
        container.addChild(button_unmute);
        button_mute.visible = sound.muted;
        button_unmute.visible = !sound.muted;
        return container;

    }
    ,
    createPauseMenu: function (json, panel_help, panel_confirm, closeFunction) {
        var container = new PIXI.Container();
        container.addChild(this.createClickBlocker());
        container.addChild(this.createAsset(json.panel));
        container.addChild(this.createMuteButton(json.button_mute, json.button_unmute, false));
        var help_function = function () {
            container.hide();
            // closeFunction.call(null);
            panel_help.show(closeFunction);
        };
        container.addChild(this.createButtonAsset(json.button_help, help_function));
        var home_function = function () {
            container.hide();
            // closeFunction.call(null);
            panel_confirm.show(function () {
                CC.WebApp.current.swapScreen(Screens.startScreen());
            }, closeFunction);
        };
        container.addChild(this.createButtonAsset(json.button_home, home_function));
        var replay_function = function () {
            container.hide();
            // closeFunction.call(null);
            panel_confirm.show(function () {
                CC.WebApp.current.swapScreen(Screens.gameScreen());
            }, closeFunction);
        };
        container.addChild(this.createButtonAsset(json.button_replay, replay_function));
        var continue_function = function () {
            container.hide();
            closeFunction.call(null);
        }.bind(this);
        container.addChild(this.createButtonAsset(json.button_continue, continue_function));
        var button_close = this.createButtonAsset(json.button_close, continue_function);
        container.addChild(button_close);
        container.show = function () {
            sound.pause(true);
            container.visible = true;
        };
        container.hide = function () {
            sound.pause(false);
            container.visible = false;
        };
        container.visible = false;
        container.resize = function (w, h) {
            button_close.resize(w, h);
        };
        return container;
    }
    ,
    createSettingsMenu: function (json, panel_help, closeFunction) {
        var container = new PIXI.Container();
        container.addChild(this.createClickBlocker());
        container.addChild(this.createAsset(json.panel));
        container.addChild(this.createMuteButton(json.button_mute, json.button_unmute, true));
        var help_function = function () {
            container.hide();
            if (closeFunction) closeFunction.call(null);
            panel_help.show();
        };
        var helpButton = this.createButtonAsset(json.button_help, help_function);
        container.addChild(helpButton);

        var home_function = function () {
            container.hide();
            if (closeFunction) closeFunction.call(null);
            CC.WebApp.current.swapScreen(Screens.startScreen());
        };
        container.addChild(this.createButtonAsset(json.button_home, home_function));
        var continue_function = function () {
            container.hide();
            if (closeFunction) closeFunction.call(null);
        }.bind(this);
        container.addChild(this.createButtonAsset(json.button_continue, continue_function));
        var button_close = this.createButtonAsset(json.button_close, continue_function);
        container.addChild(button_close);
        container.show = function () {
            container.visible = true;
        };
        container.hide = function () {
            container.visible = false;
        };
        container.hide();
        container.resize = function (w, h) {
            button_close.resize(w, h);
        };
        return container;
    }
    ,
    createConfirmationDialog: function (json) {
        var container = new PIXI.Container();

        container.show = function (confirmFunction, closeFunction) {
            container.visible = true;
            container.confirmFunction = confirmFunction;
            container.closeFunction = closeFunction;
        };
        container.hide = function () {
            if (container.closeFunction) {
                container.closeFunction.call(this);
            }
            container.visible = false;
        };

        var tickFunction = function () {
            container.confirmFunction.call(null);
        };

        container.addChild(this.createClickBlocker());
        container.addChild(this.createAsset(json.panel));
        container.addChild(this.createButtonAsset(json.button_tick, tickFunction));
        container.addChild(this.createButtonAsset(json.button_close, container.hide));

        container.hide();
        return container;
    }
    ,
    createHelpPanel: function (json) {
        var panel, instruction, image;
        var container = new PIXI.Container();
        container.show = function (closeFunction) {
            container.visible = true;
            container.closeFunction = closeFunction;
            if (panel.gotoAndPlay) panel.gotoAndPlay(0);
            if (instruction.gotoAndPlay) instruction.gotoAndPlay(0);
            if(progressImage.gotoAndPlay) progressImage.gotoAndPlay(0);
        };
        container.hide = function () {
            container.visible = false;
            if (container.closeFunction) {
                container.closeFunction.call(null);
            }
        };
        container.hide();

        var clickBlocker = this.createBackgroundAsset(json.bg);
        clickBlocker.interactive = true;
        container.addChild(clickBlocker);

        panel = this.createAsset(json.panel);
        var title = Widgets.createAsset(json.title_image);
        var instructionsPanel = Widgets.createAsset(json.instructions_background);

        instruction = Widgets.createAsset(json.instructions);


        var progressImage = this.createAsset(json.progress_image);

        container.addChild(instructionsPanel, instruction, panel, title, progressImage);
        container.addChild(this.createButtonAsset(json.button_close, container.hide));

        return container;
    }
    ,
    createClickBlocker: function (alpha) {
        if (!alpha) alpha = 0.5;
        var clickBlocker = new PIXI.Graphics();
        clickBlocker.beginFill(0, alpha);
        clickBlocker.drawRect(-400, -600, 800, 1200);
        clickBlocker.endFill();
        clickBlocker.interactive = true;
        return clickBlocker;
    }
};